import React, { useEffect, useMemo, useState } from "react";
import mainPortrait from "../img/accueil.webp";

// Configuration des animations
const HERO_LINES = [
  { text: "BONJOUR, JE SUIS", className: "hello" },
  { text: "TANGUY", className: "name1" },
  { text: "PERROIT", className: "name2" }
];

const LETTER_DELAY = 0.05;
const LETTER_BASE_DELAY = 0.05;

const FAN_CARDS = [
  {
    id: "top",
    style: {
      "--fan-x": "-5%",
      "--fan-y": "4%",
      "--fan-rotate": "-18deg",
      "--fan-scale": "1.03",
      "--fan-delay": "0.9s",
    },
    image: mainPortrait // Tu peux utiliser différentes images ici
  },
  {
    id: "left",
    style: {
      "--fan-x": "4%",
      "--fan-y": "2%",
      "--fan-rotate": "6deg",
      "--fan-scale": "1.04",
      "--fan-delay": "0.9s",
    },
    image: mainPortrait // Tu peux utiliser différentes images ici
  },
];

function AnimatedHero() {
  const [isVisible, setIsVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0.5, y: 0.5 });

  useEffect(() => {
    // Déclenche l'animation après un court délai
    const timer = window.setTimeout(() => setIsVisible(true), 100);
    
    // Effet parallaxe au mouvement de la souris
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const { innerWidth, innerHeight } = window;
      setMousePosition({
        x: clientX / innerWidth,
        y: clientY / innerHeight
      });
    };

    const handleMouseLeave = () => {
      setMousePosition({ x: 0.5, y: 0.5 });
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  // Calcul des lettres avec leurs délais
  const lettersByLine = useMemo(() => {
    let offset = 0;
    return HERO_LINES.map((line) => {
      const chars = line.text.split("");
      const letters = chars.map((char, index) => ({
        char,
        delay: LETTER_BASE_DELAY + (offset + index) * LETTER_DELAY,
        key: `${line.text}-${index}`,
      }));
      offset += chars.length;
      
      return {
        id: line.text,
        letters,
        className: line.className
      };
    });
  }, []);

  // Calcul du style parallaxe - valeurs réduites pour éviter l'effet bizarre
  const parallaxStyle = {
    transform: `perspective(1200px) rotateY(${(mousePosition.x - 0.5) * 8}deg) rotateX(${-(mousePosition.y - 0.5) * 5}deg)`,
    transformOrigin: 'center center'
  };
  
  // Style parallaxe pour les cartes uniquement (optionnel)
  const cardsParallaxStyle = {
    transform: `translate(-50%, -50%) perspective(1000px) rotateY(${(mousePosition.x - 0.5) * 12}deg) rotateX(${-(mousePosition.y - 0.5) * 8}deg)`
  };

  const headlineLabel = HERO_LINES.map(l => l.text).join(" ");
  const sectionClassName = [
    "hero-animated",
    isVisible ? "is-visible" : "",
  ].filter(Boolean).join(" ");

  return (
    <section className={sectionClassName}>
      <div className="hero-animated__inner" style={parallaxStyle}>
        <div className="hero-animated__copy">
        <h1 className="hero-animated__headline" aria-label={headlineLabel}>
          {lettersByLine.map((line) => (
            <span
              className={`hero-animated__line hero-animated__line--${line.className}`}
              key={line.id}
            >
              {line.letters.map((letter) => (
                <span
                  key={letter.key}
                  className="hero-animated__letter"
                  style={{ "--delay": `${letter.delay}s` }}
                >
                  {letter.char}
                </span>
              ))}
            </span>
          ))}
        </h1>

        <p className="hero-animated__baseline">
          Photographe professionnel à Tours et en Centre-Val de Loire
        </p>
        </div>

        <div className="hero-animated__cards" aria-hidden="true">
          {/* Option : Tu peux appliquer cardsParallaxStyle ici à la place */}
          {/* <div className="hero-animated__cards" aria-hidden="true" style={cardsParallaxStyle}> */}
          {/* Cartes en éventail */}
          {FAN_CARDS.map((card) => (
            <div
              className={`hero-animated__card hero-animated__card--fan hero-animated__card--${card.id}`}
              key={card.id}
              style={card.style}
            >
              <img src={card.image} alt="" loading="lazy" />
              <span className="hero-animated__card-overlay" />
            </div>
          ))}
          
          {/* Carte principale */}
          <div className="hero-animated__card hero-animated__card--main">
            <img src={mainPortrait} alt="Portrait de Tanguy Perroit" loading="lazy" />
          </div>
        </div>
      </div>

      <div className="scroll-indicator" aria-hidden="true" />
    </section>
  );
}

export default AnimatedHero;